module.exports = __webpack_public_path__ + "media/images/features/7/plan-konintodoke3-d5d5696189d21fd481b82baf7584d390.png";